import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { LoginService } from './services/login.service';
import { ListService } from './services/list.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css',]
})
export class AppComponent implements OnInit{
  title = 'Simple Grocery List';


  constructor(private router: Router,
              public loginService:LoginService,
              public listService:ListService) {
  }

  ngOnInit(){
    if (!this.loginService.loggedIn) {
      if (document.location.pathname != "/login") {
        this.router.navigate(['/login']);
      }
    } else {
      if (document.location.pathname != "/home") {
        this.router.navigate(['/home']);
      }
    }
  }

}
